import { useEffect, useRef } from 'react'
import { useAuth } from 'torqcloud-ui'
import { appConfig } from '@/config'

const CRISP_SCRIPT_URL = 'https://client.crisp.chat/l.js'

const loadCrisp = (websiteId: string): Array<unknown[]> => {
  if (!window.$crisp) {
    window.$crisp = []
    window.CRISP_WEBSITE_ID = websiteId
    const script = document.createElement('script')
    script.src = CRISP_SCRIPT_URL
    script.async = true
    document.head.appendChild(script)
  }
  return window.$crisp
}

/**
 * Loads the Crisp chat widget only for signed-in users and identifies them so support
 * conversations show the user's email/name. Anonymous visitors (login, sign-up) never get
 * the widget, which kept it from being used as an open spam inbox (WF-2831).
 */
export const useCrisp = () => {
  const { isAuthenticated, user } = useAuth()
  const email = user?.email
  const name = user?.name
  const wasIdentified = useRef(false)

  useEffect(() => {
    const websiteId = appConfig.crispWebsiteId
    if (!websiteId) return

    if (isAuthenticated && email) {
      const crisp = loadCrisp(websiteId)
      crisp.push(['set', 'user:email', [email]])
      if (name) {
        crisp.push(['set', 'user:nickname', [name]])
      }
      crisp.push(['do', 'chat:show'])
      wasIdentified.current = true
    } else if (!isAuthenticated && wasIdentified.current && window.$crisp) {
      // Logout stays in the SPA, so the already-loaded widget has to be hidden by hand
      window.$crisp.push(['do', 'session:reset'])
      window.$crisp.push(['do', 'chat:hide'])
      wasIdentified.current = false
    }
  }, [isAuthenticated, email, name])
}
